<template>
  <el-dialog
    title="Bulk Update"
    visible
    width="80vw"
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <el-alert
      v-show="!isMostRecentAndActiveRateCards"
      title="All selected Rate Cards must be the most recent and active, please review the history"
      type="error"
      :closable="false"
    />

    <el-alert
      v-show="!isSameCarrierRateCards"
      title="Cannot bulk update accross multiple Carriers"
      type="error"
      :closable="false"
    />

    <h1>Rate Card Updates</h1>
    <el-form
      ref="bulkUpdateForm"
      v-loading="isSaving"
      label-position="top"
      :model="params"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Start"
            prop="date_start"
          >
            <el-date-picker
              v-model="dateStart"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a Start Date"
              :picker-options="datePickerOption"
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="End"
            prop="date_end"
          >
            <el-date-picker
              v-model="dateEnd"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a End Date"
              :picker-options="datePickerOption"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item
            label="Active"
            prop="active"
          >
            <el-select
              v-model="active"
              placeholder="Active"
              class="w-100"
            >
              <el-option
                label="Active"
                :value="true"
              />
              <el-option
                label="Inactive"
                :value="false"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Filter By Service"
            prop="carrier_service"
          >
            <el-select
              v-model="carrierService"
              value-key="id"
              filterable
              placeholder="Carrier Service"
              :loading="isLoadingServices"
              class="w-100"
              clearable
            >
              <el-option
                v-for="service in carrierServices"
                :key="service.id"
                :label="service.name"
                :value="service"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <h1>Rates Updates</h1>

      <el-alert
        v-show="!hasUpdateSelected"
        title="You must bulk update at least one field"
        type="error"
        :closable="false"
      />

      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item label="Cubic">
            <el-radio-group v-model="cubic.type">
              <el-radio-button :label="null">
                <FontAwesomeIcon :icon="['fal', 'ban']" />
              </el-radio-button>
              <el-radio-button :label="1">
                <FontAwesomeIcon :icon="['fal', 'divide']" />
              </el-radio-button>
              <el-radio-button :label="2">
                <FontAwesomeIcon :icon="['fal', 'equals']" />
              </el-radio-button>
              <el-radio-button :label="3">
                <FontAwesomeIcon :icon="['fal', 'plus']" />
              </el-radio-button>
            </el-radio-group>

            <el-input-number
              v-model="cubic.value"
              :disabled="cubic.type === null"
              controls-position="right"
              placeholder="Cubic"
              class="ml-2"
            />
          </el-form-item>
        </el-col>

        <el-col :md="12">
          <el-form-item label="Min. Charge">
            <el-radio-group v-model="min_charge.type">
              <el-radio-button :label="null">
                <FontAwesomeIcon :icon="['fal', 'ban']" />
              </el-radio-button>
              <el-radio-button :label="1">
                <FontAwesomeIcon :icon="['fal', 'divide']" />
              </el-radio-button>
              <el-radio-button :label="2">
                <FontAwesomeIcon :icon="['fal', 'equals']" />
              </el-radio-button>
              <el-radio-button :label="3">
                <FontAwesomeIcon :icon="['fal', 'plus']" />
              </el-radio-button>
            </el-radio-group>

            <el-input-number
              v-model="min_charge.value"
              :disabled="min_charge.type === null"
              controls-position="right"
              placeholder="Min Charge"
              :precision="4"
              class="ml-2"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <h1>Breaks Updates</h1>
      <el-row :gutter="10">
        <el-col :md="12">
          <el-form-item label="Basic">
            <el-radio-group v-model="basic.type">
              <el-radio-button :label="null">
                <FontAwesomeIcon :icon="['fal', 'ban']" />
              </el-radio-button>
              <el-radio-button :label="1">
                <FontAwesomeIcon :icon="['fal', 'divide']" />
              </el-radio-button>
              <el-radio-button :label="2">
                <FontAwesomeIcon :icon="['fal', 'equals']" />
              </el-radio-button>
              <el-radio-button :label="3">
                <FontAwesomeIcon :icon="['fal', 'plus']" />
              </el-radio-button>
            </el-radio-group>

            <el-input-number
              v-model="basic.value"
              :disabled="basic.type === null"
              controls-position="right"
              placeholder="Basic"
              :precision="4"
              class="ml-2"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item label="Rate">
            <el-radio-group v-model="cost.type">
              <el-radio-button :label="null">
                <FontAwesomeIcon :icon="['fal', 'ban']" />
              </el-radio-button>
              <el-radio-button :label="1">
                <FontAwesomeIcon :icon="['fal', 'divide']" />
              </el-radio-button>
              <el-radio-button :label="2">
                <FontAwesomeIcon :icon="['fal', 'equals']" />
              </el-radio-button>
              <el-radio-button :label="3">
                <FontAwesomeIcon :icon="['fal', 'plus']" />
              </el-radio-button>
            </el-radio-group>
            <el-input-number
              v-model="cost.value"
              :disabled="cost.type === null"
              controls-position="right"
              placeholder="Rate"
              :precision="4"
              class="ml-2"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :disabled="validateForm"
        :loading="isSaving"
        @click.native="duplicate"
      >
        Duplicate
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    rateCards: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      params: {},
      dateStart: null,
      dateEnd: null,
      active: true,
      carrierService: null,
      cubic: {
        type: null,
        value: 0
      },
      min_charge: {
        type: null,
        value: 0
      },
      basic: {
        type: null,
        value: 0
      },
      cost: {
        type: null,
        value: 0
      },
      isSaving: false,
      isFullscreen: false,
      carrierServices: [],
      isLoadingServices: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  computed: {
    hasUpdateSelected () {
      return (this.cubic.type || this.min_charge.type || this.basic.type || this.cost.type)
    },
    isSameCarrierRateCards () {
      return this.rateCards.every(rateCard => rateCard.carrier.id === this.rateCards[0].carrier.id)
    },
    isMostRecentAndActiveRateCards () {
      return this.rateCards.every(rateCard => rateCard.is_most_recent && rateCard.active)
    },
    validateForm () {
      return !((this.hasUpdateSelected && this.isSameCarrierRateCards && this.isMostRecentAndActiveRateCards))
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Carrier Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.rateCards[0].carrier.id }
      }).then(res => { this.carrierServices = res })
        .finally(() => { this.isLoadingServices = false })
    },
    duplicate () {
      this.isSaving = true
      const job = new this.$sdk.job()
      job.name = 'bulk.combined'
      job.parameters = {
        model_key: 'ratecard',
        duplicate: this.rateCards.map(rateCard => rateCard.id),
        update: {
          fields: {
            date_start: this.dateStart ? this.$moment(this.dateStart).format('YYYY-MM-DD 00:00:00') : null,
            date_end: this.dateEnd ? this.$moment(this.dateEnd).format('YYYY-MM-DD 00:00:00') : null,
            active: this.active,
            profile: this.$user.instance.id
          },
          relations: {
            rates: {
              fields: {},
              filters: {},
              relations: {
                priceBreaks: {
                  fields: {}
                }
              }
            }
          }
        }
      }
      if (this.carrierService) job.parameters.update.relations.rates.filters['rate_card_rate_carrier_service'] = this.carrierService.id
      if (this.cubic.type) job.parameters.update.relations.rates.fields['cubic'] = this.cubic
      if (this.min_charge.type) job.parameters.update.relations.rates.fields['min_charge'] = this.min_charge
      if (this.basic.type) job.parameters.update.relations.rates.relations.priceBreaks.fields['basic'] = this.basic
      if (this.cost.type) job.parameters.update.relations.rates.relations.priceBreaks.fields['cost'] = this.cost

      job.create()
        .then(() => this.$message({ message: 'Job has been added to the queue', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.$emit('update:isShow', false)
        })
    }
  }
}
</script>
